import { render, staticRenderFns } from "./MultiLoanDisbursementTypePage.vue?vue&type=template&id=9b298aa2&scoped=true"
import script from "./MultiLoanDisbursementTypePage.vue?vue&type=script&lang=ts"
export * from "./MultiLoanDisbursementTypePage.vue?vue&type=script&lang=ts"
import style0 from "./MultiLoanDisbursementTypePage.vue?vue&type=style&index=0&id=9b298aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b298aa2",
  null
  
)

export default component.exports